import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n';

import { getToolbarButtons } from '../../../base/config';

import { Filmstrip, _connect } from './Filmstrip';

class RPC_Filmstrip extends Filmstrip {
    constructor(props) {
        super(props);
    }
    _renderToggleButton() {
        return null;
    }
}

function _mapStateToProps(state) {
    const remoteVideosVisible = true;
    const toolbarButtons = getToolbarButtons(state);
    const reduceHeight
        = (!state['features/participants-pane'].isOpen && state['features/toolbox'].visible && toolbarButtons.length) || state["features/whiteboard"].isOpen;
    const { isOpen: shiftRight } = state['features/chat'];
    const className = `${remoteVideosVisible ? '' : 'hide-videos'} ${
        reduceHeight ? 'reduce-height' : ''
    } ${shiftRight ? 'shift-right' : ''}`.trim();
    return {
        _className: className
    };
}

export default _connect(connect(_mapStateToProps)(RPC_Filmstrip));